import { useGetBaseVariant } from './useGetBaseVariant';
import { findDeep } from 'deepdash-es/standalone';
import { useMemo } from 'react';

export function useGetVariant(id) {
    const baseVariant = useGetBaseVariant();

    const activeVariant = useMemo(() => {
        if (!baseVariant) return undefined;

        const result = findDeep(
            [baseVariant],
            (value) => {
                return value.id === id;
            },
            { childrenPath: 'children' },
        );

        return result?.value;
    }, [baseVariant, id]);

    return activeVariant;
}
